export const stringToHslColor = (str: string, s: number, l: number, a?: number) => {
    var hash = 0;
    for (var i = 0; i < str?.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%,' + (a ? a : 100) + '%)';
}

export const encodeQuery = (data: any) => {
    let query = data.url
    for (let d in data.params)
        query += encodeURIComponent(d) + '='
            + encodeURIComponent(data.params[d]) + '&';
    return query.slice(0, -1)
}

export const getComponentProps=(item:any)=>{
    const a8window:any=window
    const windowConfig=a8window[item?.json?.type] || {}
    const configs=windowConfig?.data?.config || {}
     let componentProperties={};
    Object.keys(configs).forEach((k)=>{
     if(configs[k]?.type==Function && !item?.json?.properties[k]){
        componentProperties={...componentProperties,[k]:configs[k]?.default}
     }
    })
    return componentProperties
}

export function redirectOnLogin(token: string) {
  const redirectTo = sessionStorage.getItem("redirectTo")
  if(redirectTo && window.env.GENAI_URL && redirectTo === window.env.GENAI_URL) {
    sessionStorage.removeItem("redirectTo")
    const href = `${redirectTo}/#/auth/callback?token=${token}`
    window.location.href = href
    return true
  }
  return false
}

export const FormatBytes = (bytes: string, decimals = 2): string => {
    const numBytes = Number(bytes);
    if (isNaN(numBytes) || numBytes < 0) return "Invalid size";
    if (numBytes === 0) return "0 Bytes";
  
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(numBytes) / Math.log(k));
    return parseFloat((numBytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
  };
